// ※サーバから返ってきている情報を使っている項目で、ページに反映されないデータもあるので注意
const imgPath = '/static/img/yearluck/y2023/'
const dirKey = 'kanoucoco'

const info = {
  name: '叶ここ',
  itemId: 6407,
  lpId: 2, //なければ0
  pkgTitle: '暮れの酉の2022年のあなたの運勢あああああああああああああああ',
  price: 999,
  memberPrice: 500,
  pkgDescription: 'パッケージの説明文が入ります。パッケージの説明文が入ります。パッケージの説明文が入ります。パッケージの説明文が入ります。パッケージの説明文が入ります。パッケージの説明文が入ります。パッケージの説明文が入ります。',
  pkgNotice: '',
}

const top = {
  thumbnail: `${imgPath}top/counselor/${dirKey}/top_thumnail.png`,
  pkgTitleImg: `${imgPath}top/counselor/${dirKey}/top_pkg_title_img.png`,
  pkgBackImg: `${imgPath}top/counselor/${dirKey}/top_bg.png`,
}

const input = {
  thumbnail: `${imgPath}input/counselor/${dirKey}/input_thumnail.png`,
  fukiImage: `${imgPath}input/counselor/${dirKey}/input_fuki.png`,
  pkgBackImg: `${imgPath}input/counselor/${dirKey}/bg_topinfo.png`,
  headInfoBgUpp: `${imgPath}input/counselor/${dirKey}/bg_input_headinfo_upper.png`,
  headInfoBgMdl: `${imgPath}input/counselor/${dirKey}/bg_input_headinfo_middle.png`,
}

const result = {
  title: '魔女占い師・叶ここが占う<br>◆2023年の恋・結婚・金運',
  thumbnail: `${imgPath}result/counselor/${dirKey}/teller_icon_2.png`,
  underThumbnail: `${imgPath}result/counselor/${dirKey}/teller_icon.png`,
  description: '今日は鑑定に来てくださり、ありがとうございます。1年の運気の流れを知っておけば、格段に過ごしやすくなります。あなたの2023年が豊かに過ごせますように、くわしく占っていきますね。',
  bottomFukiMessage: '鑑定はいかがでしたか？　あなたの新しい1年が明るく幸せに過ごせますように。<br>次は、「仕事の才能」や「人生の分岐点」について、もう少しお伝えさせてくださいね。',
}

export default {
  info,
  top,
  input,
  result,
}



// WEBPACK FOOTER //
// ./resources/assets/js/utvStore/components/YearLuck/y2023/data/counselor/pkg07_kanou_coco.js